/* unplugin-vue-components disabled */import script from "./TabBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./TabBlock.vue?vue&type=script&lang=ts&setup=true"

import "./TabBlock.vue?vue&type=style&index=0&id=67ec443b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ec443b"]])

export default __exports__